export default function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-datepicker/~/date-fns/esm/_lib/assign/index.js
// module id = 1722
// module chunks = 2 4 5